/**
 *
 * Qlist
 *
 */

import TrackerButton from '@/components/TrackerButton.vue';

export default {
  name: 'QaSearchForm',

  components: {
    TrackerButton,
  },

  data: () => {
    return {
      queryString: '',
    };
  },

  methods: {
    makeSearchUrlParamsAndGo(params) {
      this.$emit('query-search', params);
    },

    doSearch() {
      this.makeSearchUrlParamsAndGo({
        queryString: this.queryString,
        pageNo: 0,
      });
    },
  },

  created() {
    if (this.$route.query.queryString) {
      this.queryString = this.$route.query.queryString;
    }
  },
};
